export interface RecordsState {
    auditChangedEntities: {
        /* instanceId | timestamp | parentRecordId : string[]
        '481aa2c0-2ffa-11f0-914f-0f863a71633e|1750413267846|': ['subentity'];
        '481aa2c0-2ffa-11f0-914f-0f863a71633e|1750413267846|4fca7110-46a9-11f0-97f9-096a2e7cc46a#-': ['subentity1']; */
        [property: string]: string[];
    };
    recordIds: {
        //<orgId> vs <serviceId> map
        [property: string]: {
            //<serviceId> vs <instanceId> Map
            [property: string]: {
                //<instanceId> vs <parentRecordId>|<entityId> Map or
                [property: string]: {
                    // <parentRecordId>|<entityId> vs recordsData
                    [property: string]: {
                        recordIds: string[];
                        loading: boolean;
                        pageSize: number;
                        currentPageIndex: number;
                        pagingState: string;
                        searchRecordIds: string[];
                        searchCriteria: string;
                        reconSpecific: {
                            source1: {
                                pageSize: number;
                                currentPageIndex: number;
                                criteria: any;
                                recordIds: string[];
                                pagingState: string;
                            };
                            source2: {
                                pageSize: number;
                                currentPageIndex: number;
                                criteria: any;
                                recordIds: string[];
                                pagingState: string;
                            };
                            grouped: {
                                pageSize: number;
                                currentPageIndex: number;
                                criteria: any;
                                recordIds: string[];
                                pagingState: string;
                            };
                        };
                    };
                };
            };
        };
    };
    records: {
        [property: string]: {
            id: string;
            fields: {
                id: string;
                value: any;
                errors: string[];
                warnings: string[];
            }[];
            errors: string[];
            warnings: string[];
            parentId: string;
            assetDataId: string;
        };
    };
    changeLogs: {
        [recordId: string]: {
            userName: string;
            modifiedDate: string;
            oldValue: string;
            newValue: string;
            fieldId: string;
            isGridColumn: boolean;
        }[];
    };
}

export const recordsState: RecordsState = {
    records: {},
    recordIds: {},
    auditChangedEntities: undefined,
    changeLogs: {},
};
